import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, TextComponent } from '@monorepo/react-components';
import { useStore } from '../../helpers/use-store';
import { ContactSupportButton } from './contact-support-button';

export const MailRejected = ({
  isLoading,
  message,
}: {
  isLoading: boolean;
  message: ReactNode;
}) => {
  const {
    dataStore: { userStore },
  } = useStore();

  const { t } = useTranslation(['mailConfirmation']);

  return (
    <Flex align="center" vertical gap={15} className="mail-modal">
      <TextComponent
        level={2}
        weight={600}
        className="title"
        textAlign="center"
      >
        {t('error_title')}
      </TextComponent>
      <TextComponent textAlign="center">{message}</TextComponent>
      <TextComponent level={3} weight={500}>
        {userStore.currentUser.email}
      </TextComponent>
      <ContactSupportButton
        flow="mail-confirmation"
        isLoading={isLoading}
        type="primary"
      />
    </Flex>
  );
};
